/**
 * @overview Shadows helper
 */

export const buttonShadowDefault = `0 0.125rem 0.25rem 0 rgba(0,0,0,0.50), inset 0 0.0625rem 0.1875rem 0 rgba(0,0,0,0.50)`;
export const textShadowDefault = `0 0.125rem 0.25rem 0 rgba(0,0,0,0.50)`;
